import { toNano } from '@ton/core';
import { useTonConnectUI } from '@tonconnect/ui-react';

// Treasury Wallet Address (получатель TON)
export const TREASURY_WALLET_ADDRESS = 'UQB5BeYzGOVpoS-ZV0HYmkkSu9eolnzdtgYZ-wfuUh4gbvaD';

export interface SendTonParams {
  tonConnectUI: ReturnType<typeof useTonConnectUI>[0];
  amount: number; // в TON (человекочитаемая форма), обязательно > 0
}

/**
 * Отправляет нативные TON через TON Connect
 */
export async function sendTonTransaction(params: SendTonParams): Promise<string> {
  const { tonConnectUI, amount } = params;

  // Получаем treasury wallet из API или используем константу
  let treasuryWallet = TREASURY_WALLET_ADDRESS;
  try {
    const response = await fetch('/api/billing/treasury');
    const data = await response.json();
    if (data.success && data.data?.walletAddress) {
      treasuryWallet = data.data.walletAddress;
    }
  } catch (error) {
    // Используем константу если API недоступен
    console.warn('Failed to fetch treasury wallet, using default:', treasuryWallet);
  }

  if (!treasuryWallet) {
    throw new Error('Treasury wallet address not configured');
  }

  // Формируем транзакцию для отправки нативных TON
  const transaction = {
    validUntil: Math.floor(Date.now() / 1000) + 600, // 10 минут
    messages: [
      {
        address: treasuryWallet,
        amount: toNano(amount).toString(),
      },
    ],
  };

  // Отправляем через TON Connect
  const result = await tonConnectUI.sendTransaction(transaction);

  if (!result.boc) {
    throw new Error('Transaction failed - no BOC returned');
  }

  return result.boc;
}
